import { useNavigate } from "@tanstack/react-router"
import { useLocale } from "@holigral/shared/routing"
import { getRefreshToken } from "./refreshTokenStorage"
import { useLogoutMutation } from "./api"
import { clearAuth } from "./slice"
import { useDispatch } from "@/base/store"

export default () => {
  const [logout] = useLogoutMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const locale = useLocale()

  return async () => {
    // Land on the public home (avoids storing a post-login redirectUrl)
    await navigate({ to: "/$locale", params: { locale } })
    const refreshToken = getRefreshToken()
    if (refreshToken) {
      await logout(refreshToken)
    }
    dispatch(clearAuth())
  }
}
